export const environment = {
	production: false,
	estado: "Staging! 😎",
	url_api: "https://api.staging.gofeels.com/api/v1",
	HK_API_KEY: 'qJHWUZJpn75uaR62ml1Fyo20EaveMmHo',
};
